import * as React from 'react';

import { IsFromPriceSpiderAccessor } from '../../Purchase/IsFromPriceSpiderAccessor';
import { GoogleTagManager } from '../../Tracking/GoogleTagManager/GoogleTagManager';
import { GoogleTagManagerList } from '../../Tracking/GoogleTagManager/GoogleTagManagerList';
import { ProductViewModel } from './ViewModels/ProductViewModel.csharp';

export const ProductImpression = ({ model }: { model: ProductViewModel }) => {
    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const originName = params.get('originName') ?? GoogleTagManagerList.productPage;
        const promotionId = params.get('promotionId') ?? undefined;
        const promotionName = params.get('promotionName') ?? undefined;

        GoogleTagManager.productDetails(model, originName, promotionId, promotionName);
        if (params.get('utm_source') == 'pricespider') {
            IsFromPriceSpiderAccessor.set(model.code);
        }
    }, []);

    return null;
};
